<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">
	{{TR "API Token"}} {{#if isNewToken}}{{TR "anlegen"}}{{else}}- {{formData.name}}{{/if}}
	</h4>
</div>
<div class="modal-body">
	{{#WIZARD wizardContext}}
		{{#WIZARD-TAB 'Devices'}}
			<center>
				{{#SELECT formData.groups}}
				<select multiple="multiple" class="multi-select" id="group_multi_select" name="groups">
					{{#each groups}}
						<option value="{{id}}">{{name}}</option>
					{{/each}}
				</select>
				{{/SELECT}}
			</center>
		{{/WIZARD-TAB}}
		{{#WIZARD-TAB 'Token'}}
			<div class="row">
				<div class="col-sm-12">
					<div class="form-group">
						<label for="name" class="control-label">{{TR "Name"}}</label>
						<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="name" placeholder="{{TR "Bezeichnung des Tokens"}}" value="{{formData.name}}">
						{{#if errors.name}}
							<ul class="parsley-errors-list filled" id="js-name-error">
								<li class="parsley-required">{{TR errors.name}}</li>
							</ul>
						{{/if}}
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<label for="expiration" class="control-label">{{TR "Ablaufdatum"}}</label>
					<div class="input-group">
					    <input type="text" class="form-control js-datepicker {{#if errors.expiration}}parsley-error{{/if}}" id="expiration-input" name="expiration" placeholder="{{noExpirationText}}" value="{{#COMPARE formData.expiration '!=' '0001-01-01'}}{{formData.expiration}}{{/COMPARE}}">
						{{#if errors.expiration}}
						<ul class="parsley-errors-list filled" id="js-expiration-error">
						    <li class="parsley-required">{{TR errors.expiration}}</li>
						</ul>
						{{/if}}
						<span class="input-group-btn" style="vertical-align: top">
						    <button id="js-remove-expiration" class="btn btn-white"><i class="fa fa-trash"></i></button>
						</span>
					</div>
				</div>
				<div class="col-sm-6">
					<label for="source_ip" class="control-label">{{TR "Zulässiger IP Bereich"}}</label>
					<div class="row">
						<div class="col-sm-12">
							<div class="form-group">
								<input type="text" class="form-control {{#if errors.source_ip}}parsley-error{{/if}}" id="source_ip-input" name="source_ip" placeholder="{{TR "CIDR"}}" value="{{formData.source_ip}}">
								{{#if errors.source_ip}}
									<ul class="parsley-errors-list filled" id="js-source_ip-error">
										<li class="parsley-required">{{TR errors.source_ip}}</li>
									</ul>
								{{/if}}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
                <div class="col-sm-6">
                    <label for="hourly_limit" class="control-label">{{TR "Anfragenlimit pro Stunde"}}</label>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <input type="number" min="0" max="600" class="form-control {{#if errors.hourly_limit}}parsley-error{{/if}}" id="hourly_limit-input" name="hourly_limit" placeholder="{{TR "Max. Anzahl pro Stunde"}}" value="{{formData.hourly_limit}}">
                                {{#if errors.hourly_limit}}
                                <ul class="parsley-errors-list filled" id="js-hourly_limit-error">
                                    <li class="parsley-required">{{TR errors.hourly_limit}}</li>
                                </ul>
                                {{/if}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                	<label for="monthly_limit" class="control-label">{{TR "Anfragenlimit pro Monat"}}</label>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <input type="number" min="0" max="450000" class="form-control {{#if errors.monthly_limit}}parsley-error{{/if}}" id="monthly_limit-input" name="monthly_limit" placeholder="{{TR "Max. Anzahl pro Monat"}}" value="{{formData.monthly_limit}}">
                                {{#if errors.monthly_limit}}
                                <ul class="parsley-errors-list filled" id="js-monthly_limit-error">
                                    <li class="parsley-required">{{TR errors.monthly_limit}}</li>
                                </ul>
                                {{/if}}
                            </div>
                        </div>
                    </div>
                </div>
			</div>
{{!--
	for now: disabled! - API Token have to be "enhanced" in DB.

			<div class="row">
				<div class="col-sm-12">
					<div class="checkbox checkbox-primary">
						<input
							class="js-checkbox-adv"
							id="cb-modbus-access"
							name="js-modbus-access"
							type="checkbox"
							{{#if formData.modbus_access}}checked="checked"{{/if}}
						>
						<label for="cb-modbus-access">{{TR "Lese- und Schreibzugriff via Modbus erlauben"}}</label>
					</div>
				</div>
			</div>
--}}
		{{/WIZARD-TAB}}
	{{/WIZARD}}
</div>
<div class="modal-footer">{{{WIZARD-BUTTONS wizardContext}}}</div>
